/* eslint-disable react/prop-types */
import {
  Checkbox,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DeleteSharp, SyncSharp } from "@material-ui/icons";
import { PlayCircle } from "@mui/icons-material";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Select from "components/Select/Select";
import { chainOptions } from "const";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { indexConfigService } from "services/indexConfigService";
import "../../assets/css/global.css";
import { networkConfig } from "const";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const defaultValues = {
  address: "",
  chainId: 25,
};

const CollectionIndexList = () => {
  const classes = useStyles();
  const { register, handleSubmit, control } = useForm({ defaultValues });
  const [isLoading, setIsLoading] = useState(false);
  const [isCollectionExternal, setIsCollectionExternal] = useState(false);
  const [collections, setCollections] = useState([]);

  async function onSubmit(form) {
    try {
      if (!form.chainId) {
        toast.error("Please choose chain");
        return;
      }
      console.log("isCollectionExternal: ", isCollectionExternal);

      setIsLoading(true);
      await handleCreate(form.chainId, form.address, isCollectionExternal);
      toast.success("Create index success");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  async function handleCreate(chainId, address, isCollectionExternal) {
    await indexConfigService.createJob(Number(chainId), address, isCollectionExternal);
    fetchData();
  }

  async function fetchData() {
    try {
      const { data } = await indexConfigService.list();
      setCollections(data);
    } catch (error) {
      console.log(error);
    }
  }

  async function createJobSyncIndexMetadata(chainId, address) {
    await indexConfigService.createJobSyncIndexMetadata(chainId, address);
    toast.success("Syncing metadata");
  }

  async function toggleLive(chainId, address) {
    await indexConfigService.toggleLive(chainId, address);
    fetchData();
  }

  async function handleDelete(chainId, address) {
    const response = window.confirm(`Are you sure you want to delete ${address}?`);
    if (!response) {
      return;
    }
    await indexConfigService.delete(chainId, address);
    toast.success("Delete data success");
    fetchData();
  }

  useEffect(() => {
    fetchData();
  }, []);
  console.log({ isCollectionExternal });

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
          <div style={{ width: 400 }}>
            <CustomInput
              labelText="ADDRESS"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                ...register("address"),
              }}
            />
          </div>

          <div style={{ width: 200 }}>
            <Controller
              control={control}
              name="chainId"
              render={({ field: { value, onChange } }) => (
                <Select
                  name="chainId"
                  label="Chain"
                  onChange={onChange}
                  value={value ?? "25"}
                  options={chainOptions()}
                />
              )}
            />
          </div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 10, paddingBottom: 10 }}>
            <Button color="rose" type="submit">
              {isLoading ? "Loading..." : "Add"}
            </Button>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                title="Collection External"
                onChange={(e) => {
                  setIsCollectionExternal(e.target.checked);
                }}
                checked={isCollectionExternal}
              />
              <p style={{ margin: 0 }}>Collection External</p>
            </div>
          </div>
        </div>
      </form>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Chain</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Index Point</TableCell>
              <TableCell>Total Indexed</TableCell>
              <TableCell>Total Metadata Indexed</TableCell>
              <TableCell>Running</TableCell>
              <TableCell>Live</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {collections.map((row, i) => (
              <TableRow key={i}>
                <TableCell>{i + 1}</TableCell>
                <TableCell>{networkConfig[row.chainId]?.chainName}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.indexPoint}</TableCell>
                <TableCell>{row.total}</TableCell>
                <TableCell>
                  {row.totalMetadata}
                  <IconButton onClick={() => createJobSyncIndexMetadata(row.chainId, row.address)}>
                    <SyncSharp />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <IndexNft row={row} reload={() => fetchData()} />
                </TableCell>
                <TableCell>
                  <Switch
                    checked={row.live}
                    onChange={() => toggleLive(row.chainId, row.address)}
                  />
                </TableCell>

                <TableCell>
                  <>
                    <Tooltip title="Delete">
                      <IconButton
                        onClick={() => {
                          handleDelete(row.chainId, row.address);
                        }}
                      >
                        <DeleteSharp />
                      </IconButton>
                    </Tooltip>
                    <FixNftButton
                      chainId={row.chainId}
                      address={row.address}
                      reload={() => fetchData()}
                    />
                  </>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CollectionIndexList;

const FixNftButton = ({ chainId, address, reload }) => {
  const [loading, setLoading] = useState(false);

  async function handleFixAll(chainId, address) {
    const response = window.confirm(`Are you sure you want to fix ${address}?`);
    if (!response) {
      return;
    }
    setLoading(true);
    await indexConfigService.fix(chainId, address);
    toast.success("Fix all nft success");
    setLoading(false);
    reload();
  }

  return (
    <Tooltip title="Fix all nft">
      <IconButton
        className={`${loading ? "spin" : ""}`}
        onClick={() => handleFixAll(chainId, address)}
      >
        <SyncSharp />
      </IconButton>
    </Tooltip>
  );
};

const IndexNft = ({ row, reload }) => {
  const [isLoading, setIsLoading] = useState(row.running);

  async function createJob(chainId, address) {
    try {
      setIsLoading(true);
      await indexConfigService.createJob(chainId, address);
      toast.info("Please wait to index data");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      reload();
    }
  }
  console.log(isLoading);

  return (
    <>
      {isLoading ? (
        "Running"
      ) : (
        <Tooltip title="Start Indexing">
          <IconButton onClick={() => createJob(row.chainId, row.address)}>
            <PlayCircle />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};
